import { createFileRoute } from '@tanstack/react-router';
import ContactsPage from '../../views/dashboard-contacts';

export const Route = createFileRoute('/dashboard/contacts/')({
  component: ContactsPage,
});
